const ENDPOINT = '/api/bbr';

const BBR_USER_INIT = 'BBR/USER_INIT';
const BBR_USER_SUCCESS = 'BBR/USER_SUCCESS';
const BBR_USER_FAILED = 'BBR/USER_FAILED';

const initialState = {
  data: null,
  loading: false,
  error: null
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case BBR_USER_INIT:
      return {
        data: null,
        loading: true,
        error: null
      };

    case BBR_USER_SUCCESS:
      return {
        data: action.payload,
        loading: false,
        error: null
      };

    case BBR_USER_FAILED:
      return {
        data: null,
        loading: false,
        error: action.error || true
      };

    default:
      return state;
  }
}

/**
 * Fetch a BBR user by id
 * Example id: e3996ad4-b831-4ef6-bc99-8e445dab39b0
 */
export function bbrUser(id /*: string */) {
  return {
    types: [BBR_USER_INIT, BBR_USER_SUCCESS, BBR_USER_FAILED],
    promise: (client) =>
      client
        .get(`${ENDPOINT}/user/${id}`)
        .then((res) => (res && res.data ? res.data : res))
  };
}
